var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_138_2920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.955078,
    y: 0.488281,
    width: 50.5814,
    height: 50.5814,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_138_2920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2657 45.8007L8.31146 28.0972L18.2207 16.052H34.2908L44.2005 28.0972L26.2657 45.8007ZM11.5292 15.5045L7.21289 11.2083L9.4664 8.98744L13.7827 13.2837L11.5292 15.5045ZM24.6856 11.8369V5.75708H27.8464V11.8369H24.6856ZM40.8975 15.5045L38.664 13.251L42.9602 8.95477L45.2137 11.2083L40.8975 15.5045ZM26.2657 41.379L38.3036 29.5077H14.2084L26.2657 41.379ZM19.7165 19.2128L13.8111 26.3463H38.7009L32.7955 19.2128H19.7165Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progress-icon.12318bc1507024e17b3ac6a823cdeb85.svg";
export { ForwardRef as ReactComponent };